import React, { useState } from 'react';
import { formatMonedaSimbolo } from '../../libs/moneda';
import { formatNumber } from '../../utils/formatNumber';
import { calcularArrendamiento } from '../../helpers/arrendamientoHelper';
import '../landing/brand.css';

/**
 * Calculadora de arrendamiento en kilos de hacienda (sección de /precios).
 * El alquiler se paga en pesos: siempre ARS, sin el selector de moneda.
 */

export interface ReferenciaArrendamiento {
  clave: string;
  label: string;
  /** Aclaración de la fuente y la fecha del precio. */
  detalle: string;
  precioKg: number | null;
}

const ArrendamientoKilos: React.FC<{ referencias: ReferenciaArrendamiento[] }> = ({ referencias }) => {
  const disponibles = referencias.filter((r) => r.precioKg && r.precioKg > 0);
  const [clave, setClave] = useState(disponibles[0]?.clave ?? '');
  const [kgPorHa, setKgPorHa] = useState(50);
  const [hectareas, setHectareas] = useState(100);

  if (disponibles.length === 0) return null;
  const ref = disponibles.find((r) => r.clave === clave) ?? disponibles[0];
  const resultado = calcularArrendamiento(kgPorHa, hectareas, ref.precioKg);
  const pesos = (v: number) => formatMonedaSimbolo(v, 'ARS');

  return (
    <div className="lp-card lp-card--lift" id="calculadora-arrendamiento">
      <div className="lp-card__h">
        <h3>Calculá el alquiler en pesos</h3>
      </div>
      <div style={{ display: 'grid', gap: 12, gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))' }}>
        <label className="lp-note">
          Kilos por hectárea al año
          <input
            type="number"
            min={0}
            inputMode="decimal"
            className="lp-control"
            value={kgPorHa || ''}
            onChange={(e) => setKgPorHa(parseFloat(e.target.value) || 0)}
          />
        </label>
        <label className="lp-note">
          Hectáreas
          <input
            type="number"
            min={0}
            inputMode="decimal"
            className="lp-control"
            value={hectareas || ''}
            onChange={(e) => setHectareas(parseFloat(e.target.value) || 0)}
          />
        </label>
        <label className="lp-note">
          Precio de referencia
          <select className="lp-control" value={ref.clave} onChange={(e) => setClave(e.target.value)}>
            {disponibles.map((r) => (
              <option key={r.clave} value={r.clave}>
                {r.label}
              </option>
            ))}
          </select>
        </label>
      </div>

      <p className="lp-note" style={{ marginTop: 10 }}>
        {ref.detalle}: <strong>{pesos(ref.precioKg!)} por kilo</strong>.
      </p>

      {resultado ? (
        <table className="lp-scope lp-prices" style={{ marginTop: 8 }}>
          <tbody>
            <tr>
              <td>Kilos por año</td>
              <td>{formatNumber(resultado.kgTotales)} kg</td>
            </tr>
            <tr>
              <td>Alquiler por hectárea</td>
              <td>{pesos(resultado.montoPorHa)}</td>
            </tr>
            <tr>
              <td>
                <strong>Alquiler anual</strong>
              </td>
              <td>
                <strong>{pesos(resultado.montoAnual)}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      ) : (
        <p className="lp-note">Completá los kilos por hectárea y las hectáreas.</p>
      )}
    </div>
  );
};

export default ArrendamientoKilos;
